'use strict'

import format from 'string-format'
import session from './session'
import {obj_to_FormData} from "./utils"

export default {

	/**
	 *
	 * @param project_id
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	sample_list(project_id) {

		const params = {}
		if (project_id) {
			// фильтр в Django
			params['projects_id'] = project_id
		}

		return session.get('sample/', {params: params})
			.catch(function (error) {
				console.error(format(
					"method: '{method}' url: '{url}'" + "\n" +
					"error: '{error}'.",
					{
						method: error.config.method,
						url: error.config.url,
						error: error.toString()
					}))
				throw error
			})
	},

	sample_create: function (sample, details = true) {
		return session.request({
			method: 'POST',
			url: format('sample/'),
			// headers: {'Content-Type': 'multipart/form-data',},
			data: sample,
		})
	},

	sample_update: function (sample, details = true) {
		let data = obj_to_FormData(sample)
		return session.request({
			method: 'PATCH',
			url: format('sample/{id}/', {id: sample.id}),
			// headers: {'Content-Type': 'multipart/form-data',},
			data: sample
		})
	},

	samples_delete: function (sample_id_list) {
		return session.request({
			method: 'POST',
			url: format('sample/delete_list/'),
			data: sample_id_list
		})
	},
}
